"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAcceptanceTemplateName = exports.SalesChannel = exports.CustomerSegment = exports.CONTRACT_ROUTE_TO_MARKET = exports.CONTRACT_MODEL = exports.CONTRACT_BUYING_PROGRAM = exports.getTermsToAccept = exports.TermsAcceptance = exports.putContractAcceptTerms = exports.hasOnlyTrialContracts = exports.hasIndirectContract = exports.hasEnterpriseContract = exports.hasAllocationContract = exports.getIndirectContract = exports.getContractsNeedTermsAcceptance = exports.getContractList = exports.useContractList = exports.Contract = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

var Contract_1 = require("./Contract");

Object.defineProperty(exports, "Contract", {
  enumerable: true,
  get: function () {
    return Contract_1.Contract;
  }
});

var ContractList_hook_1 = require("./ContractList-hook");

Object.defineProperty(exports, "useContractList", {
  enumerable: true,
  get: function () {
    return ContractList_hook_1.useContractList;
  }
});

var contractListUtils_1 = require("./contractListUtils");

Object.defineProperty(exports, "getContractList", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.getContractList;
  }
});
Object.defineProperty(exports, "getContractsNeedTermsAcceptance", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.getContractsNeedTermsAcceptance;
  }
});
Object.defineProperty(exports, "getIndirectContract", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.getIndirectContract;
  }
});
Object.defineProperty(exports, "hasAllocationContract", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.hasAllocationContract;
  }
});
Object.defineProperty(exports, "hasEnterpriseContract", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.hasEnterpriseContract;
  }
});
Object.defineProperty(exports, "hasIndirectContract", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.hasIndirectContract;
  }
});
Object.defineProperty(exports, "hasOnlyTrialContracts", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.hasOnlyTrialContracts;
  }
});
Object.defineProperty(exports, "putContractAcceptTerms", {
  enumerable: true,
  get: function () {
    return contractListUtils_1.putContractAcceptTerms;
  }
});

var TermsAcceptance_1 = require("./TermsAcceptance");

Object.defineProperty(exports, "TermsAcceptance", {
  enumerable: true,
  get: function () {
    return TermsAcceptance_1.TermsAcceptance;
  }
});

var termsAcceptanceUtils_1 = require("./termsAcceptanceUtils");

Object.defineProperty(exports, "getTermsToAccept", {
  enumerable: true,
  get: function () {
    return termsAcceptanceUtils_1.getTermsToAccept;
  }
});

var types_1 = require("./types");

Object.defineProperty(exports, "CONTRACT_BUYING_PROGRAM", {
  enumerable: true,
  get: function () {
    return types_1.CONTRACT_BUYING_PROGRAM;
  }
});
Object.defineProperty(exports, "CONTRACT_MODEL", {
  enumerable: true,
  get: function () {
    return types_1.CONTRACT_MODEL;
  }
});
Object.defineProperty(exports, "CONTRACT_ROUTE_TO_MARKET", {
  enumerable: true,
  get: function () {
    return types_1.CONTRACT_ROUTE_TO_MARKET;
  }
});
Object.defineProperty(exports, "CustomerSegment", {
  enumerable: true,
  get: function () {
    return types_1.CustomerSegment;
  }
});
Object.defineProperty(exports, "SalesChannel", {
  enumerable: true,
  get: function () {
    return types_1.SalesChannel;
  }
});
Object.defineProperty(exports, "TermsAcceptanceTemplateName", {
  enumerable: true,
  get: function () {
    return types_1.TermsAcceptanceTemplateName;
  }
});